import React, { useState, useEffect } from "react";
import Header1 from "./Header1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faPhone } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Footer";
import { ServiceBanner } from "./ServiceBanner";
import "../../Styles/seperate Comp Css/CaseStudy.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import Spinner from "./Spinner";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import { Helmet } from "react-helmet";
import cocimg from "../../assets/All Images/Ambrella CoC Blank2.png";
import cocimg1 from "../../assets/All Images/CoC Aug1.png";
import cocimg2 from "../../assets/All Images/CoC Core1.png";
import cocimg3 from "../../assets/All Images/CoC Ext1.png";
import cocmain from "../../newimgs/contactimg.png";
import config from "../../config";
const Competencies = () => {
  const toggleContact = () => {
    scroll.scrollToTop(0, 0);
  };

  return (
    <div>
      <Helmet>
        <title>Competencies</title>
      </Helmet>

      <Header1 />

      {/* Banner section */}

      {/* //backup classes */}
      {/* <div
        className="bd-page-title-area bd-page-title-bg_career pt-120 pb-20 main-heading comp-heading"
        
      > */}
              <div
        className=" pt-120 pb-20 main-heading comp-heading"
        
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bd-page-title text-center z-index">
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "38px", color: "#01536E" }}
                >
                  Competencies
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      {/* How We Help Your Business to get Automised and Succeed! */}
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <section className="bd-service-details-area pt-80 pb-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-lg-8 case-study-section">
              <div className="bd-service-details">
                <div className="bd-service-details-img ">
                  <img
                    src={studies.detailed_image}
                    className="main-image1"
                    alt="img not found"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="bd-service-area competenciesOne pt-40">
        <div className="container text-center" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-lg-6 col-md-6 bd-case-studies-section1">
              <div className="bd-service1- mb-30">
                <h4 className="bd-service-title mb-20">
                  The greatest results come not from fixing our weaknesses, but
                  from combining our strengths and sharpening our core
                  competencies
                </h4>
                <p>
                  <span style={{fontSize:"16px"}}>(ChatGPT, 2025)</span>
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 bd-case-studies-section2">
              <div className="bd-service1-">
                <h4 className="bd-service-title mb-20">
                  Ambrella Consulting's core philosophy is to avoid being a
                  'jack-of-all and master-of-none'.
                </h4>
                <p className=" mb-20" style={{fontSize:"16px"}}>
                  Our ethos is based on offering world-class solutions and
                  guidance to our clients and we @ Ambrella firmly believe this
                  can only happen when we have deep knowledge and competency in
                  the subject domains.
                </p>
                <p className=" mb-20" style={{fontSize:"16px"}}>
                  {" "}
                  We are constantly sharpening our tools, bringing new people
                  onboard and forging new partnerships to expand our 'Circle of
                  Competence'.
                </p>
                <ul className="mb-45" style={{ listStyle: "none" }}>
                  <li className="case-point-sec pb-10"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bd-service-area mt-20">
        <div className="container text-center" style={{ maxWidth: "1270px" }}>
          <h4 className="mb-40 cocfont">Circle of Competence (CoC)</h4>
          <div className="row pt-80">
            <div className="col-lg-6 col-md-6 bd-case-studies-section1">
              <div className="bd-service1- mb-30">
                <img src={cocimg} />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 bd-case-studies-section2">
              <div className="bd-service1-">
                <img src={cocimg2} />
                <img src={cocimg3} />
                <img src={cocimg1} />
                <ul className="mb-45" style={{ listStyle: "none" }}>
                  <li className="case-point-sec pb-10"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bd-service-area mt-40 mb-40">
        <div className="container text-center" style={{ maxWidth: "1270px" }}>
          <h4 className="mb-40 cocfont">Partnerships power progress</h4>
          <div className="row">
            <div className="col-lg-12 col-md-6 bd-case-studies-section1">
              <div className="bd-service1- mb-30">
                <img src={cocmain} />
              </div>
            </div>
            <div className="col-lg-12 col-md-6 bd-case-studies-section2 mt-20">
              <div className="bd-service1-">
                <h4 className="bd-service-title mb-20" style={{fontSize:"38px"}}>
                  Where strengths converge,<br/> success expands
                </h4>
                <p className=" mb-20" style={{fontSize:"16px"}}>
                  In business, true growth begins when we stop competing with<br/>
                  each other and start completing each other.
                </p>
                <p className=" mb-20" style={{fontSize:"16px"}}>
                  {" "}
                  Ambrella's vision is to grow through collaborations with the<br/>
                  best problem solvers on the planet.
                </p>
                <p className=" mb-20" style={{fontSize:"16px"}}>
                  {" "}
                  Whether you are freelancer with deep domain expertise or a<br/>
                  startup with a compelling and innovative product idea or an <br/>
                  existing enterprise which is looking out to expand its reach,<br/>
                  we are always keen to speak and explore ways of working<br/>
                  together.
                </p>
                <Link to={`${config.appurl}contact-us`} className="theme-btn mr-2 themebtn2-1 mb-20">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#01536E" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Looking for Business Automation Expert?
                </h2>
                <p className="contact_section second-para-resp">
                  You're at the right place. The right time
                </p>
                <p className="contact_subtext">
                  Surprisingly great results achieved, Let's get started right
                  now !
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:(+91)720-288-2277"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    (+91) 720-288-2277
                  </a>
                </div>
              </div>
       
            </div>
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default Competencies;
